<template>
  <div class="last-played-last-played grid-pasttrack">
    <last-track
      v-for="(track, idx) in paddedLastTracks"
      :key="track && track.title ? track.title + idx : 'placeholder-' + idx"
      :artist="track.artist"
      :title="track.title"
      :album="track.album"
      :year="track.year"
      :discogsUrl="track.discogs_url"
      :imageUrl="track.image_url"
      :favorited="track.favorited"
      v-if="track"
      @toggle-favorite="$emit('toggle-favorite', idx)"
      @open-signup="$emit('open-signup')"
    />
    <div v-else :key="'placeholder-' + idx" class="last-track-placeholder" v-once></div>
  </div>
</template>

<script>
import LastTrack from "./last-track";

export default {
  name: "LastPlayed",
  props: {
    lastTracks: {
      type: Array,
      default: [],
    },
  },
  components: {
    LastTrack,
  },
  computed: {
    paddedLastTracks() {
      // Always return an array of length 6, filling with nulls if needed
      const tracks = this.lastTracks.slice(0, 6);
      while (tracks.length < 6) tracks.push(null);
      return tracks;
    },
  },
};
</script>

<style scoped>
.last-played-last-played {
  position: relative;
  /* GPU acceleration for better performance */
  transform: translateZ(0);
  will-change: transform;
}
.grid-pasttrack {
  width: 100%;
  display: grid;
  padding: 4px;
  align-self: center;
  grid-row-gap: 4px;
  grid-column-gap: 4px;
  justify-content: center;
  background-color: #ffffff;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(3, 1fr);
}
.last-track-placeholder {
  background: #f0f0f0;
  border-radius: 8px;
  min-height: 120px;
  min-width: 80px;
  opacity: 0.5;
}
@media (max-width: 991px) {
  .grid-pasttrack {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
